"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getEnsuredProjectIdFromProcessor_1 = __importDefault(require("../getEnsuredProjectIdFromProcessor"));
const callableSetUserCustomData = async ({ entryVars: { key, value, }, callbacks, functionId, processor, executeProcesses, }) => {
    try {
        const database = processor.root.firebase.database();
        if (typeof key !== 'string') {
            processor.root.alert('Invalid key when setting user custom data', `${key}`);
            throw new Error(`Invalid key when setting user custom data [${key}]`);
        }
        const { currentUser } = processor.root.firebase.auth();
        if (!currentUser) {
            executeProcesses(functionId, callbacks.notLoggedIn, { message: 'No user logged in' });
        }
        else {
            const projectId = (0, getEnsuredProjectIdFromProcessor_1.default)('setUserCustomData', processor);
            const appId = processor.root.getAppId();
            if (!appId) {
                throw new Error('setUserCustomData: no appId found in app');
            }
            const memberCustomDataRef = database
                .ref(`projects/${projectId}/apps/${appId}/members/${currentUser.uid}/customData`);
            const actualValue = value === undefined ? null : value;
            await memberCustomDataRef.child(key).set(actualValue);
            await processor.root.loadFirebaseUserInfo();
            executeProcesses(undefined, callbacks.then);
        }
    }
    catch (error) {
        executeProcesses(functionId, callbacks.error, error);
    }
};
exports.default = callableSetUserCustomData;
